// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { MessageProcessorBase } from './MessageProcessorBase';
import { DirectMarginCallMessage } from '@shared/utils/DirectMessages/DirectMarginCallMessage';
import { generateReportMessageHandler } from '@shared/utils/AppHandlers';
export class MarginCallMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const msg = new DirectMarginCallMessage();
        msg.UserId = fieldSet.GetValue(FieldsFactory.FIELD_ACCOUNT_ID);
        msg.AssetId = fieldSet.GetValue(FieldsFactory.FIELD_ASSET_ID);
        msg.StopOutType = fieldSet.GetValue(FieldsFactory.FIELD_STOPOUT_TYPE);
        msg.Balance = fieldSet.GetValue(FieldsFactory.FIELD_BALANCE);
        msg.UsedMargin = fieldSet.GetValue(FieldsFactory.FIELD_USED_MARGIN);
        msg.IsMarginCall = fieldSet.GetValue(FieldsFactory.FIELD_IS_MARGINCALL) === false;
        return [generateReportMessageHandler.GenerateReportMessage(msg)]; // [msg];
    }
}
